import { render, staticRenderFns } from "./VehicleBasicInfoForm.vue?vue&type=template&id=702c2908&"
import script from "./VehicleBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./VehicleBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('702c2908')) {
      api.createRecord('702c2908', component.options)
    } else {
      api.reload('702c2908', component.options)
    }
    module.hot.accept("./VehicleBasicInfoForm.vue?vue&type=template&id=702c2908&", function () {
      api.rerender('702c2908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Forms/VehicleBasicInfoForm.vue"
export default component.exports